import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import FacetDataContext from '~/context/common/FacetDataContext';
import useGetFilterTags from './useGetFilterTags';

export default function useAppliedFilterTagsCount(): number {
  const { baseline } = useContext(FacetDataContext);
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const filterTags = useGetFilterTags(baseline, appliedFilters, {
    includeVehicleAlerts: true
  });

  return filterTags.length;
}
